import { createContext } from 'react';
export const WizardContext = createContext();
WizardContext.displayName = 'WizardContext';
